module.exports = __webpack_public_path__ + "img/woocommerce.a4f4e78f.svg";